module.exports = "::ng-deep .assign-report .columns .column:first-child {\n  margin-right: 24px;\n}\n"